import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild, ViewChildren, ChangeDetectorRef, ElementRef, Renderer2, QueryList } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { logbaseService } from "../../services/logbase.service";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router'
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from "@ngx-translate/core";
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator} from '@angular/material/paginator'
import { MatSort } from '@angular/material/sort'

export interface DeliveryPointData{
  deliveryPoint:any;
  unlisted:any;
}

@Component({
  selector: 'app-delivery-point',
  templateUrl: './delivery-point.component.html',
  styleUrls: ['./delivery-point.component.scss']
})
export class DeliveryPointComponent implements OnDestroy, OnInit {
  deliverypoint:any;
  toListDelPoint: any;
  missingDPList: any;
  missingDPData: any[];
  disableUnlistedDP: boolean;
  missingDP: any;
  disableSaveBtn: boolean = true;
  disableAddBtn: boolean = true;
  editDataPlantName: any;
  editDataDP: any;
  delPoint: any;
  plantName: any;
  DPData: any;
  missingPlant: any;
  modalRef: NgbModalRef;
  route: string;
  public rows: Array<any> = [];
  plantNameList = ["Atsugi", "CC Yokohama", "HO", "K1", "K2", "MFBM", "Nakatsu", "Resale_Direct", "Resale_K2", "TAA_HQ"]
  public columns: Array<any> = []

  public page: number = 1;
  public itemsPerPage: number = 50;
  public maxSize: number = 5;
  public numPages: number = 1;
  public length: number = 0;
  public totalItems: any;
  searchText: any;
  public config: any;

  private data: Array<any> = [];
  
  constructor(private router: Router,
    private http: HttpClient,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private logbaseService: logbaseService,
    private renderer: Renderer2, private translate: TranslateService,
    private spinner: NgxSpinnerService, private ref: ChangeDetectorRef) {

      this.columns = [
        { title: this.translate.instant('Delivery_Point'), name: 'deliveryPoint' },
        { title: this.translate.instant('Unlisted'), name: 'unlisted' }
      ];
      this.config =  {
        paging: true,
        sorting: { columns: this.columns },
        filtering: { filterString: '' },
        className: ['table-striped', 'table-bordered']
      };
  }
  displayedColumns = ['deliveryPoint', 'unlisted'];
  dataSource: MatTableDataSource<DeliveryPointData[]>;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit() {
    this.getDeliveryPoint();
  };

  getDeliveryPoint() {
    this.logbaseService.getDeliveryPoints()
      .subscribe(result => {
        this.DPData = result.response;
        this.spinner.hide();
      });
    this.onChangeTable(this.config, true);
  }

  saveChanges(toListDelPoint, plantNameAddition) {
    this.spinner.show();
    var dataToSend = {
      deliveryPoint: toListDelPoint,
      plantName: plantNameAddition,
      createdDate: null,
      createBy: null,
      updatedDate: null,
      updatedBy: null
    };

    let updateMissingdata = {
      "deliveryPoint": toListDelPoint,
      "missing": false
    }

    this.logbaseService.checkDeliveryPoint(toListDelPoint)
      .subscribe(result => {
        if (result.response) {
          if (result.response.deliveryPoint == toListDelPoint) {
            this.toastr.error(this.translate.instant('DEL_POINT_EXIST'));
            this.spinner.hide();
          } else {
            this.logbaseService.saveDeliveryPoint(dataToSend)
              .subscribe(result => {
                this.logbaseService.updateMissingDeliveryPoint(updateMissingdata).subscribe(
                  result => {
                    this.toastr.success(this.translate.instant('DEL_POINT_CREATE_SUCCESS'));
                    this.rerender();
                    this.spinner.hide();
                  })
              })
          }
        }
        this.modalRef.close();
      });
  };

  updateChanges() {
    this.spinner.show();
    let dataToSend = {
      deliveryPoint: this.editDataDP,
      plantName: this.editDataPlantName,
      createdDate: null,
      createBy: null,
      updatedDate: null,
      updatedBy: null
    };

    this.logbaseService.saveDeliveryPoint(dataToSend)
      .subscribe(result => {
        this.toastr.success(this.translate.instant('DEL_POINT_UPDATE_SUCCESS'));
        this.modalRef.close();
        this.rerender();
      });
  };

  enableAddBtn(event) {
    if (this.delPoint == undefined || this.plantName == undefined || this.plantName == "" || this.plantName == null) {
      this.disableAddBtn = true;
    } else {
      this.disableAddBtn = false;
    }
  };

  enableSaveBtn(event) {
    if (this.editDataPlantName == undefined || this.editDataPlantName == '') {
      this.disableSaveBtn = true;
    } else {
      this.disableSaveBtn = false;
    }
  };

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
  };


  public changePage(page: any, data: Array<any> = this.data): Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  public changeSort(data: any, config: any): any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName: string = void 0;
    let sort: string = void 0;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous: any, current: any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  public changeFilter(data: any, config: any): any {
    let filteredData: Array<any> = data;
    this.columns.forEach((column: any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item: any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item: any) =>
        item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray: Array<any> = [];
    filteredData.forEach((item: any) => {
      let flag = false;
      this.columns.forEach((column: any) => {
        if (item[column.name]) {
          if (item[column.name].toString().match(this.config.filtering.filterString)) {
            flag = true;
          }
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }


  paginate(event:any)
  {
    var dataToSend = {
      pageNum: event.page,
      searchValue: "",
      size: this.itemsPerPage,
      sortColumn:'unlisted',
      // sortType: sortData ? sortData.sort : ''
    }

    this.spinner.show();
    this.logbaseService.missingDeliveryPointPaginated(dataToSend)
      .subscribe(result => {
        this.missingDP = result;
        var partArr;
        this.totalItems=this.missingDP.response.totalElements;
        var partsData = [];
        this.spinner.hide();
        this.missingDP.response.content.forEach(function (value, key) {
          partArr = {
            deliveryPoint: value.deliveryPoint,
            // plantName: '<td>' + '<select  class="form-control" [(ngModel)]="plantNameMissing"><option value="Atsugi">Atsugi</option><option value="">CC Yokohama</option>' +
            // '<option value="">HO</option><option value="" >K1</option><option value="">K2</option><option value="">MFBM</option>' +
            //    '<option value="">Nakatsu</option><option value="">Resale_Direct</option><option value="">Resale_K2</option><option value="">TAA_HQ</option></select >'+'</td>',
            unlisted: '<td>' + '<i class="fa fa-plus-circle" aria-hidden="true" >&nbsp;</i>' + 'Add Delivery Point' + '</td>'
          };
          partsData.push(partArr);
        });

        this.missingDPData = partsData;
        this.dataSource=new MatTableDataSource<DeliveryPointData[]>(this.missingDPData)
      })
  }

  
  public onChangeTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {


    var pageNo;
    var sortData;
    var tempFilterString;

    if (page.page == undefined) {
      pageNo = 0;
    } else {
      pageNo = (page.page) - 1;
    }

    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
      tempFilterString = config.filtering;
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    // To set sorting value based on column sorted
    this.config.sorting.columns.forEach(function (value, key) {
      if (value.sort != '') {
        sortData = {
          name: value.name,
          sort: value.sort
        }
      }
    });

    var dataToSend = {
      pageNum: pageNo,
      searchValue: this.deliverypoint,
      size: this.itemsPerPage,
      sortColumn: sortData ? sortData.name : '',
      sortType: sortData ? sortData.sort : ''
    }

    this.spinner.show();
    this.logbaseService.missingDeliveryPointPaginated(dataToSend)
      .subscribe(result => {
        this.missingDP = result;
        var partArr;
        this.totalItems=this.missingDP.response.totalElements;
        var partsData = [];
        this.spinner.hide();
        this.missingDP.response.content.forEach(function (value, key) {
          partArr = {
            deliveryPoint: value.deliveryPoint,
            // plantName: '<td>' + '<select  class="form-control" [(ngModel)]="plantNameMissing"><option value="Atsugi">Atsugi</option><option value="">CC Yokohama</option>' +
            // '<option value="">HO</option><option value="" >K1</option><option value="">K2</option><option value="">MFBM</option>' +
            //    '<option value="">Nakatsu</option><option value="">Resale_Direct</option><option value="">Resale_K2</option><option value="">TAA_HQ</option></select >'+'</td>',
            unlisted: '<td>' + '<i class="fa fa-plus-circle" aria-hidden="true" >&nbsp;</i>' + 'Add Delivery Point' + '</td>'
          };
          partsData.push(partArr);
        });

        this.missingDPData = partsData;
        this.dataSource=new MatTableDataSource<DeliveryPointData[]>(this.missingDPData)
        this.data = partsData;
        this.length = this.missingDP.response.totalElements;

        this.columns = [
          { title: this.translate.instant('DELIVERYPOINT'), name: 'deliveryPoint' },
          // { title: this.translate.instant('DELIVERYPLANTNAME'), name: 'plantName' },
        ];

        let filteredData = this.changeFilter(this.data, this.config);
        let sortedData = this.changeSort(filteredData, this.config);
        this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
        this.rerenderTable(this.config, true);
        this.ref.detectChanges();
        this.spinner.hide();
      });
  }

  openPopup(value) {
    this.modalRef = this.modalService.open(value, { backdrop: false })
  }

  value(val) {
  }

  confirmUnlistAdd(confirm, val) {
    console.log("event",val)
    this.toListDelPoint = val.deliveryPoint;
    // if (val.column === 'unlisted') {
      this.modalRef = this.modalService.open(confirm, { backdrop: false })
    //}
    }

  emitChange(val) {
  }

  public rerenderTable(config: any, page: any = { page: this.page, itemsPerPage: this.itemsPerPage }): any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    //this.length = sortedData.length;
  }


  rerender() {
    this.onChangeTable(this.config, true);
    this.logbaseService.getDeliveryPoints()
      .subscribe(result => {
        this.DPData = result.response;
        this.spinner.hide();
      });

    this.delPoint = '';
    this.plantName = '';
    this.disableAddBtn = true;
  }

  exportCSV() {
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      useBom: true,
      headers: ['Delivery Point', 'Plant Name']
    };
    new AngularCsv(this.DPData, 'Available Delivery Point', options);
  }

}
